class BlogFilter extends HTMLElement {
  constructor() {
    super();

    const filter = this.querySelector('select');
    if (!filter) return;

    filter.addEventListener('change', function() {
      window.location.href = filter.value;
    });
  }
}

customElements.define('blog-filter', BlogFilter);
